import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ShiftContextService} from "../../../../services/shift-context.service";
import {ShiftContext} from "../../../../models/shift-context";
import {getSiteInfo} from "@shared/helpers/site-info";
import {WorkedShift} from "@shared/models/worked-shift";

@Component({
  selector: 'app-end-of-shift-files',
  templateUrl: './end-of-shift-files.component.html',
  styleUrls: ['./end-of-shift-files.component.scss']
})
export class EndOfShiftFilesComponent implements OnInit, OnDestroy {
    loading = false;
    context: ShiftContext;
    workedShift: WorkedShift;
    private subscriptions: Subscription[];

    constructor(private shiftContextService: ShiftContextService) { }

    ngOnInit(): void {
        this.loading = true;

        this.subscriptions = [
            this.shiftContextService.WorkedShift.subscribe(ws => this.workedShift = ws),
            this.shiftContextService.CurrentContext.subscribe((context) => {
                this.context = context;
                this.loading = false;
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getFileTypes() {
        let fileTypes = ['Inventory Tick', 'Piece Rate', 'Yard Check', 'Audits'];
        if (this.context) {
            if (getSiteInfo(this.context?.site)?.hasPlant) {
                fileTypes = ['Plant End of Shift', ...fileTypes];
            }
            if (getSiteInfo(this.context?.site)?.hasTpm) {
                fileTypes = ['TPM End of Shift', ...fileTypes];
            }
            if (getSiteInfo(this.context?.site)?.hasUac) {
                fileTypes = ['UAC End of Shift', 'Inbound BOLs', 'Unload Worksheets', 'Outbound Documents', 'Trailer Movement', 'Yard Check'];
            }
        }
        return fileTypes;
    }
}
